import { render, staticRenderFns } from "./DataReportCase.vue?vue&type=template&id=ce1dfc7c"
import script from "./DataReportCase.vue?vue&type=script&lang=js"
export * from "./DataReportCase.vue?vue&type=script&lang=js"
import style0 from "./DataReportCase.vue?vue&type=style&index=0&id=ce1dfc7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports